import { render, staticRenderFns } from "./FreshKdsSettings.vue?vue&type=template&id=abd4c784"
import script from "./FreshKdsSettings.vue?vue&type=script&lang=js"
export * from "./FreshKdsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports